function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(-0.516)"
}, /*#__PURE__*/React.createElement("g", {
  id: "streaming-tv-app"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M9.678,28.9a1.194,1.194,0,1,1,0-2.389H21.29a1.194,1.194,0,1,1,0,2.389ZM7.257,24.125A7.219,7.219,0,0,1,0,16.961v-9.8A7.221,7.221,0,0,1,7.259,0H23.71a7.221,7.221,0,0,1,7.259,7.166V16.96a7.22,7.22,0,0,1-7.259,7.166Z",
  transform: "translate(0.516)",
  fill: "#fff"
})));

function SvgDesktopI5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.968,
    height: 28.904,
    viewBox: "0 0 30.968 28.904",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopI5);
export default __webpack_public_path__ + "static/media/desktopI5.78cf7d60.svg";
export { ForwardRef as ReactComponent };